/*global $, define, dna*/
define('core/factory/RetryFactory',[
    'angular'
], function(angular) {
    'use strict';

    angular.module('dnaApp').factory('RetryInterceptor', ['$q', '$rootScope', '$timeout', '$injector',
        function RetryInterceptor($q, $rootScope, $timeout, $injector) {
            function waitingForThis(response) {
                var waitRequest = waitingRequests[response.config.url];
                if (angular.isDefined(waitRequest) && waitRequest.cancelled) {
                    delete waitingRequests[response.config.url];
                }
                return angular.isDefined(waitingRequests[response.config.url]);
            }

            function resolveRetryWith(response) {
                delete waitingRequests[response.config.url];
                return response;
            }

            function mayStillRetry(errorResponse) {
                var waitRequest = waitingRequests[errorResponse.config.url];
                if (angular.isDefined(waitRequest)) {
                    var maxRetryCount = waitTimes.length;
                    // Note: the config object attached to the errorResponse consists of whatever config options were used when the initial request was made
                    try {
                        if (errorResponse.config) {
                            var maxRetries = errorResponse.config.maxRetries;
                            if (angular.isDefined(maxRetries) && angular.isNumber(maxRetries) && maxRetries >= 0) {
                                maxRetryCount = Math.min(maxRetries, maxRetryCount);
                            }
                        }
                    } catch (err) {}
                    return waitRequest.retryCount < maxRetryCount && !waitRequest.cancelled;
                } else {
                    waitingRequests[errorResponse.config.url] = {
                        config: errorResponse.config,
                        retryCount: 0
                    };
                    return true;
                }
            }

            function retry(errorResponse) {
                var waitRequest = waitingRequests[errorResponse.config.url];
                waitRequest.config.headers['HTTP-GET-RETRY'] = errorResponse.config.url;
                var httpClient = $injector.get('$http');
                waitRequest.timeout = $timeout(function() {
                    waitRequest.retryCount += 1;
                    return httpClient(waitRequest.config);
                }, waitTimes[waitRequest.retryCount] * 1000);
                return waitRequest.timeout;
            }

            function giveUp(errorResponse) {
                var waitRequest = waitingRequests[errorResponse.config.url];
                delete waitingRequests[errorResponse.config.url];
                if (!waitRequest.cancelled) {
                    $rootScope.displayServiceErrorsBanner();
                    return $q.reject(errorResponse);
                } else {
                    return $q.reject(errorResponse);
                }
            }

            var waitTimes = [2,4,8,16,32],
                waitingRequests = {},
                response = function(response) {
                    if ( waitingForThis( response ) ) {
                        // Then resolve the retry exponential backoff loop (which will release all other requests/rejected responses waiting for this to finish).
                        return resolveRetryWith( response );
                    } else {
                        // Let it through.
                        return response;
                    }
                }, responseError = function(errorResponse) {
                    if (errorResponse && errorResponse.config && errorResponse.status && errorResponse.config.url && errorResponse.config.method) {
                        var statusCode = errorResponse.status;
                        if (statusCode >= 500 && statusCode < 600 && errorResponse.config.method === 'GET') {
                            if (mayStillRetry(errorResponse)) { // And if we can still retry
                                // Try again with the current backoff, which will eventually be resolved/rejected with the ultimately successful response or this, the ultimately error response
                                return retry(errorResponse);
                            }
                            else { // Otherwise, fail outright, which will not result in this request being rejected with this errorResponse, but all other paused requests/delayed errorResponses that were waiting for this.
                                return giveUp(errorResponse);
                            }
                        }
                    }
                    return $q.reject(errorResponse);
                }, cancelAll = function() {
                    angular.forEach(waitingRequests, function(waitingRequest) {
                        $timeout.cancel(waitingRequest.timeout);
                        waitingRequest.cancelled = true;
                    });
                };

            return {
                response: response,
                responseError: responseError,
                cancelAll : cancelAll
            };
        }
    ]);
});
